import './inventory-gift-card.scss';

import { Gem } from 'lucide-react';
import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import UploadIcon from '@/shared/assets/icons/upload.svg?react';

import type { InventoryGift } from '../../api';

type InventoryGiftCardProps = {
  item: InventoryGift;
  index: number;
  withdrawing: boolean;
  onWithdraw: (item: InventoryGift) => void;
  onDetail?: (item: InventoryGift) => void;
};

export function InventoryGiftCard({ item, index, withdrawing, onWithdraw, onDetail }: InventoryGiftCardProps) {
  const { t } = useTranslation();

  return (
    <div
      className="inventory-gift-card"
      onClick={() => onDetail?.(item)}
      style={
        {
          cursor: onDetail ? 'pointer' : undefined,
          '--card-in-delay': `${index * 0.04}s`,
        } as CSSProperties
      }>

      <div className="inventory-gift-card__media">
        {item.thumbnail_url ? (
          <img
            src={item.thumbnail_url}
            alt={item.name}
            className="inventory-gift-card__thumbnail"
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).style.display = 'none';
              (e.currentTarget.nextSibling as HTMLElement | null)?.removeAttribute('hidden');
            }}
          />
        ) : null}
        <span
          className="inventory-gift-card__emoji"
          hidden={!!item.thumbnail_url || undefined}>
          {item.emoji}
        </span>
      </div>

      <div className="inventory-gift-card__body">
        <p className="inventory-gift-card__name">{item.name}</p>
        {item.model_name && (
          <p className="inventory-gift-card__attr">{item.model_name}</p>
        )}
        <div className="inventory-gift-card__value">
          <Gem className="inventory-gift-card__value-icon" />
          <span>{item.value_ton.toFixed(2)}</span>
          <span className="inventory-gift-card__value-unit">TON</span>
        </div>
      </div>

      <button
        type="button"
        className="inventory-gift-card__btn inventory-gift-card__btn--tappable"
        disabled={withdrawing}
        onClick={(e) => { e.stopPropagation(); onWithdraw(item); }}>
        <UploadIcon className="inventory-gift-card__btn-icon" />
        {withdrawing ? '...' : t('shop.withdraw')}
      </button>
      <div className="inventory-gift-card__glow" aria-hidden />
    </div>
  );
}
